import { IMobilityOrder } from '../../../../types/mobility/IMobilityGroup';
import React, { useMemo } from 'react';
import { ClientUrlFactory } from '../../../../ui-toolkit/rest/ClientUrlFactory';
import { UUID } from '../../../../types/shared/UUID';

export const MobilityOrdersButtons = ({
  orders,
  currentOrderId,
}: {
  orders: IMobilityOrder[];
  currentOrderId: UUID;
}) => {
  const comparator = useMemo(() => {
    return (groupOrderA: IMobilityOrder, groupOrderB: IMobilityOrder) => {
      if (groupOrderA.orderId === currentOrderId) {
        return 1;
      }

      if (groupOrderB.orderId === currentOrderId) {
        return -1;
      }

      let priorityA = orderPriorityByTransactionTypes.get(groupOrderA.transactionType.id) || 0;
      let priorityB = orderPriorityByTransactionTypes.get(groupOrderB.transactionType.id) || 0;

      return priorityA - priorityB;
    };
  }, [currentOrderId]);

  const orderedGroupOrdersByTransactionType = useMemo(() => {
    if (!orders || orders.length === 0) {
      return [];
    }
    let orderedGroupOrders = [...orders];
    orderedGroupOrders.sort(comparator);
    orderedGroupOrders.reverse();
    return orderedGroupOrders;
  }, [orders, comparator]);

  return (
    <>
      {orderedGroupOrdersByTransactionType.map((mobilityOrder, index) => {
        return (
          <MobilityOrderButton
            mobilityOrder={mobilityOrder}
            index={index}
            ordersLength={orders.length}
            key={mobilityOrder.orderId}
          />
        );
      })}
    </>
  );
};

const MobilityOrderButton = ({
  mobilityOrder,
  index,
  ordersLength,
}: {
  mobilityOrder: IMobilityOrder;
  index: number;
  ordersLength: number;
}) => {
  let buttonClasses =
    'py-1 h-8 px-4 text-xs shadow-sm focus:ring-foundation-primary hover:bg-extension-foundation-primary-light text-foundation-primary ring-1 ring-extension-foundation-primary-light';

  let additionalStyles = {};

  const onClick = () => {
    window.location.href = ClientUrlFactory().urlFor.orderStatus(mobilityOrder.orderId);
  };

  if (ordersLength === 1) {
    buttonClasses = `${buttonClasses} bg-background-default-content`;
    additionalStyles = { borderRadius: '100px 100px 100px 100px' };
  } else {
    if (index === 0) {
      buttonClasses = `${buttonClasses} bg-background-default-content`;
      additionalStyles = { borderRadius: '100px 0px 0px 100px' };
    } else {
      buttonClasses = `${buttonClasses} bg-background-active-control`;
    }
    if (index === ordersLength - 1) {
      additionalStyles = { borderRadius: '0px 100px 100px 0px' };
    }
  }

  return (
    <button className={buttonClasses} style={additionalStyles} onClick={onClick}>
      {' '}
      {mobilityOrder.transactionType.label}
    </button>
  );
};

const orderPriorityByTransactionTypes = new Map<string, number>([
  ['acquisition', 3],
  ['resale', 2],
  ['destination', 1],
  ['listing', 0],
]);
